export const unsavedChangesMessage = 'There are unsaved changes that will be lost, are you sure you wish to continue?';

export const saveBeforeEditLocationMessage = 'There are unsaved changes. Do you wish to save them before editing this location?';

/**
 * Function that parses a FormikErrors object into a list of error message strings.
 * @param errInput
 * @returns
 */
export function parseFormikErrors(errInput: unknown): string[] {
	const obj = errInput as Record<string, unknown>;

	return Object.entries(obj).reduce((errorList: string[], [, value]) => {
		if (typeof value === 'object') {
			return [...errorList, ...parseFormikErrors(value)];
		} else if (typeof value === 'string') {
			return [...errorList, value];
		}
		return errorList;
	}, []);
}

export function getFieldName(fieldName: string, prefix?: string) {
	if (prefix) {
		return `${prefix}.${fieldName}`;
	}
	return fieldName;
}
